import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateTransportActions } from "store/ducks/transports";

export function* createTransportRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/transports`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateTransportActions.success(data));
    notify("success", "Carga cadastrada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateTransportActions.failure(errorMessage));
  }
}
